// eslint-disable-next-line max-len
const EMAIL_REGEX = /^(?=[A-Z0-9][A-Z0-9@._%+-]{5,253}$)[A-Z0-9._%+-]{1,64}@(?:(?=[A-Z0-9-]{1,63}\.)[A-Z0-9]+(?:-[A-Z0-9]+)*\.){1,8}[A-Z]{2,63}$/i;
export const isValidEmail = (email: string) => EMAIL_REGEX.test(email);

const SUPPORTED_PROVIDERS = [
  'aol.com',
  'facebook.com',
  'gmail.com',
  'gmx.com',
  'googlemail.com',
  'hotmail.com',
  'hotmail.co.uk',
  'icloud.com',
  'mac.com',
  'me.com',
  'mail.com',
  'msn.com',
  'live.com',
  'yahoo.com',
  'yahoo.co.uk',
];

const parseEmail = (email: string): { name: string, provider: string } => {
  const [name, provider = ''] = email.split('@');
  return { name, provider };
};
const getEmailProvider = (email: string) => parseEmail(email).provider;
export const canOpenMailClient = (email: string) => SUPPORTED_PROVIDERS.includes(getEmailProvider(email));
export const openMailClient = (email: string) => {
  if (!canOpenMailClient(email)) return;

  const provider = getEmailProvider(email);
  const url = `https://${ provider }`;
  window.open(url, '_blank');
};
